var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"facebook-template-list"},[_vm._t("default")],2),_vm._v(" "),_c('v-pagination',{staticClass:"mt-2",attrs:{"value":_vm.page,"length":_vm.totalPages,"total-visible":7},on:{"input":function($event){return _vm.$emit('update:page', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40bb2f55","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/facebook-template/FacebookTemplateList.vue
// module id = null
// module chunks = 